import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class VisaFormService {
  async getSmartserviceList() {
    try {
      const response = await HttpClient.get("/api/visaform/smartservice/list");
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getSmartserviceList2(body) {
    try {
      const params = qs.stringify({
        ...(body &&
          body.smartserviceId && { smartserviceId: body.smartserviceId }),
        ...(body && body.draftId && { draftId: body.draftId }),
        ...(body && body.personalId && { personalId: body.personalId }),
        ...(body &&
          body.TypeDocSmartFromID && {
            TypeDocSmartFromID: body.TypeDocSmartFromID,
          }),
        ...(body && body.StatausID && { StatausID: body.StatausID }),
        ...(body &&
          body.resonsibleCase && { resonsibleCase: body.resonsibleCase }),
        ...(body && body.keyword && { keyword: body.keyword }),
        ...(body && body.isActivated && { isActivated: body.isActivated }),
        ...(body && body.startDate && { startDate: body.startDate }),
        ...(body && body.endDate && { endDate: body.endDate }),
      });
      const response = await HttpClient.get(
        `/api/visaformadmin/smartfrom/list2?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getDocumentRequired({ smartserviceId, ConditionType, isUpload }) {
    try {
      const params = qs.stringify({
        ...(smartserviceId && { smartserviceId }),
        ...(ConditionType && { ConditionType }),
        isUpload: isUpload === undefined ? true : isUpload,
      });
      const response = await HttpClient.get(
        `/api/visaform/documentrequired/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getDocumentrequiredbydraftid({ draftId, isUpload }) {
    try {
      console.log(draftId);
      const params = qs.stringify({
        ...(draftId && { draftId }),
        isUpload: isUpload === undefined ? true : isUpload,
      });
      const response = await HttpClient.get(
        `/api/visaform/documentrequiredbydraftid/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getCoditionvisa({ smartserviceId, ConditionType }) {
    try {
      const params = qs.stringify({
        ...(smartserviceId && { smartserviceId }),
        ...(ConditionType && { ConditionType }),
      });
      const response = await HttpClient.get(
        `/api/visaform/coditionvisa/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getCoditionType({ smartserviceId }) {
    try {
      const params = qs.stringify({
        ...(smartserviceId && { smartserviceId }),
      });
      const response = await HttpClient.get(
        `/api/visaform/coditiontype/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getSmartFormFieldConfig({ smartserviceId, partfromId }) {
    try {
      const params = qs.stringify({
        ...(smartserviceId && { smartserviceId }),
        ...(partfromId && { partfromId }),
      });
      const response = await HttpClient.get(
        `/api/visaform/partsmart/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addSmartForm(data) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfrom/add`,
        data
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getListSmartForm({ personalId }) {
    const params = qs.stringify({
      ...(personalId && { personalId }),
    });

    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/smartfrom/list2`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getSmartForm({ personalId, smartserviceId, draftId }) {
    const params = qs.stringify({
      ...(personalId && { personalId }),
      ...(smartserviceId && { smartserviceId }),
      ...(draftId && { draftId }),
    });
    try {
      const response = await HttpClient.get(
        `/api/visaform/smartfrom/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async checkRequestSmartForm({ personalId, isRequest }) {
    const params = qs.stringify({
      isRequest: true,
      ...(personalId && { personalId }),
    });
    try {
      const response = await HttpClient.get(
        `/api/visaform/smartfrom/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async uploadDocumentCondition({
    file,
    personalID,
    conditionId,
    configConditionVisaId,
  }) {
    try {
      const formData = new FormData();
      formData.append("FileUpload", file);
      formData.append("personalID", personalID);
      formData.append("conditionId", conditionId);
      formData.append("configConditionVisaId", configConditionVisaId);
      formData.append("draftId", null);

      const response = await HttpClient.post(
        `/api/visaform/coditionvisa/upload`,
        formData,
        true
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async uploadEducationDocument({ file, personalID, fileID }) {
    try {
      const formData = new FormData();
      formData.append("FileUpload", file);
      formData.append("personalID", personalID);
      if (fileID) {
        formData.append("fileID", fileID);
      }

      const response = await HttpClient.post(
        `/api/visaform/education/upload`,
        formData,
        true
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async uploadProcessDiagram({ file, personalID, fileID }) {
    try {
      const formData = new FormData();
      formData.append("FileUpload", file);
      formData.append("personalID", personalID);
      if (fileID) {
        formData.append("fileID", fileID);
      }

      const response = await HttpClient.post(
        `/api/visaform/processdiagram/upload`,
        formData,
        true
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async uploadFileDocument({
    file,
    fileID,
    typedocId,
    personalID,
    documentID,
    Status,
    draftId,
  }) {
    try {
      const formData = new FormData();
      formData.append("personalID", personalID);
      formData.append("typedocId", typedocId);
      formData.append("documentID", documentID);
      formData.append("Status", Status);

      if (file) {
        formData.append("FileUpload", file);
      }

      if (fileID) {
        formData.append("fileID", fileID);
      }
      if (draftId) {
        formData.append("draftId", draftId);
      }

      const response = await HttpClient.post(
        `/api/visaform/filedocument/upload`,
        formData,
        true
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async submitSmartForm({ detail = [] }) {
    try {
      const response = await HttpClient.post(`/api/visaform/smartfrom/send`, {
        detail,
      });
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async smartFormChange({ personalId }) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfromchange/gen`,
        {
          personalId,
        }
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async conditionAdd({ detail = [] }) {
    try {
      const response = await HttpClient.post(`/api/visaform/condition/add`, {
        detail,
      });
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async smartfromExtension({ personalId }) {
    try {
      const response = await HttpClient.get(
        `/api/visaform/smartfromold/list?personalId=${personalId}&smartserviceIdNewFrom=ea67ab08-5953-4453-0830-28ed243a8d38`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addExtension(data) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfromextension/add`,
        data
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async checkSmartO({ SmartNo }) {
    try {
      const params = qs.stringify({
        SmartNo,
      });

      const response = await HttpClient.get(
        `/api/visaform/smartfrom/checko?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async reqdoclogAdd({ draftId, detail }) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfrom/reqdoclog/add`,
        { draftId, detail }
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async reqdoclogList(data) {
    try {
      const params = qs.stringify(data);
      const response = await HttpClient.get(
        `/api/visaformadmin/smartfrom/reqdoc/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async checkExistingSmart({ personalID }) {
    try {
      const params = qs.stringify({
        personalID,
      });

      const response = await HttpClient.get(
        `/api/visaform/smartextra/check?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async checkProjectId({ smartCompanyID, projectID }) {
    try {
      const params = qs.stringify({
        smartCompanyID,
        projectID,
      });

      const response = await HttpClient.get(
        `/api/visaform/projectid/check?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getVisaRequest({ smartserviceId }) {
    try {
      const params = qs.stringify({
        smartserviceId,
      });

      const response = await HttpClient.get(
        `/api/visaform/visarequest/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addTerminateSmartForm(data) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfromtermination/add`,
        data
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async smartfromExtensionClone(data) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfromex/clone`,
        data
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addSmartfromExtension(data) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfromex/add`,
        data
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async smartfromRequestClone(data) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfromrequest/clone`,
        data
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new VisaFormService();
